module.exports = __webpack_public_path__ + "static/media/2.a4e022b1.jpg";